export const TEXTS = {
  num_of_helpers_explanation: `
    Liczba osób, które w ciągu ostatnich 30 dni dokonały transakcji na rzecz Podopiecznego
    - zarejestrowanych oraz anonimowych użytkowników (rozumianych jako unikalne adresy IP).
  `
};

